import { Box } from '@chakra-ui/react';
import { PageHeader } from '@/components/ui';

export function VolunteersHeader() {
  return (
    <Box mb="5">
      <PageHeader title="Dashboard" />
    </Box>
  );
}
